import React from 'react';
import { css } from '@compiled/react';

import Image from '@atlaskit/image';

const imageStylesMobile = css({
	width: '68%',
});

const imageStylesDesktop = css({
	width: 'unset',
});

const centeredImageStyles = css({
	width: '275px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
	maxWidth: '100% !important',
	margin: '0 auto',
});

const imageStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
	maxWidth: 'unset !important',
	margin: '0 auto',
});

type ImageProps = {
	isMobile: boolean;
	isCenteredLayout?: boolean;
	src: string;
	srcDark?: string;
};

export function ErrorPageImage({
	src,
	srcDark,
	isMobile,
	isCenteredLayout,
}: ImageProps): React.JSX.Element {
	return (
		<Image
			alt=""
			src={src}
			srcDark={srcDark || src}
			css={[
				isCenteredLayout && centeredImageStyles,
				!isCenteredLayout && isMobile && imageStylesMobile,
				!isCenteredLayout && !isMobile && imageStylesDesktop,
				!isCenteredLayout && imageStyles,
			]}
		/>
	);
}
